'use client'

import { IsolatedDashboard } from '@/containers/IsolatedDashboard'

export default function IsolatedPage() {
  return <IsolatedDashboard />
}
